// src/http.js
import axios from "axios";
import store from "@/store";
import router from "@/router";

// Sets the default url used by all of this axios instance's requests
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.get["Accept"] = "application/json";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch("auth/logout");
      if (router.currentRoute.name !== "login") {
        router.push({ name: "login" });
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
